import React, {useMemo} from 'react';
import {Box} from '@tempo/core';
import {PasswordLevel} from '@deezer/next/shared/utils/password/validator';

type PasswordStrengthBarProps = {
	level?: PasswordLevel;
	score: number;
};

const PasswordStrengthBar = ({level, score}: PasswordStrengthBarProps) => {
	const color = useMemo(() => {
		switch (level) {
			case PasswordLevel.WEAK:
				return 'background.feedback.error.default';
			case PasswordLevel.MEDIUM:
				return 'background.feedback.warning.default';
			case PasswordLevel.STRONG:
				return 'background.feedback.success.default';
			default:
				return undefined;
		}
	}, [level]);

	return (
		<Box
			sx={{
				backgroundColor: 'background.neutral.tertiary.default',
				borderRadius: 'lg',
				height: '8px',
				marginTop: '5px',
				overflow: 'hidden',
			}}
		>
			<Box
				sx={{
					transitionDuration: 'fast',
					transitionProperty: 'background-color, width',
					height: '100%',
					width: `${score}%`,
					backgroundColor: color,
				}}
			/>
		</Box>
	);
};

export default PasswordStrengthBar;
